// Simple export of import.meta.env for browser use
// Jest will use a mock in tests/setupFiles.js instead
export const env = import.meta.env as Record<string, string | undefined>;
